import * as z from "zod";
import type { Plugin } from "vue";
import { fr } from "zod/locales";

export default {
  install(app) {
    z.config(fr());
    app.config.globalProperties.z = z;
  },
} as Plugin;

declare module "vue" {
  interface ComponentCustomProperties {
    z: typeof z;
  }
}
